import store from '@/store/index';

export class AuthGuardService {

    guard(to, from, next) {
        const date = new Date();
        const expiry = localStorage.getItem("expiry");
        const expiryNum = parseInt(expiry);

        // store url for redirection
        sessionStorage.setItem('tourl', to.fullPath)
        
        if (store.getters['auth/jwtToken'] && localStorage.getItem("expiry") && expiryNum > date.setHours(date.getHours())) {
            next();
        } else {
            store.dispatch('auth/removeStates');
            localStorage.removeItem("expiry");
            next({ name: 'viewAuthLogin' });
        }
    }

    guest(to, from, next) {
        if (store.getters['auth/jwtToken']) {
            next({name: 'viewDashboard'});
        } else next();
    }

}